import StimulusTomSelect from "stimulus-tom-select";

export class TomSelectController extends StimulusTomSelect {
    initTomSelect() {
        this.options = {
            allowEmptyOption: true,
            ...this.optionsValue,
        };
        super.initTomSelect();
    }
}